module.exports = "/_next/static/chromiums/fav-48x48-icon-27abb70b38ff04d5b587bd0aaffd776f.png";